'use client';

import { FC } from 'react';
import { SortOption } from '@/components/Product/SortBy/constants';
import { ISortOption } from '@/components/Product/SortBy/types';
import DesktopSortBy from '@/components/Product/SortBy/DesktopSortBy';
import MobileSortBy from '@/components/Product/SortBy/MobileSortBy';

type SortByProps = {
  sortBy?: ISortOption;
  onSortByChange?: (val: ISortOption) => void;
};
const SortBy: FC<SortByProps> = ({
  sortBy = SortOption.priceDesc,
  onSortByChange,
}) => {
  return (
    <>
      <MobileSortBy sortBy={sortBy} onSortByChange={onSortByChange} />
      <DesktopSortBy sortBy={sortBy} onSortByChange={onSortByChange} />
    </>
  );
};

export default SortBy;
